'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';

import { DateHelper } from '@/utils/helpers/DateHelper';

interface EventSummaryNotPublishedProps {
  publishedAt: string | Date | null;
  setIsPublished: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function EventPageNotPublished({
  publishedAt,
  setIsPublished,
}: EventSummaryNotPublishedProps) {
  const t = useTranslations();
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const updateCountdown = () => {
      if (!publishedAt) {
        setTimeLeft(0);
        setIsPublished(true);
        return;
      }
      const now = new Date();
      const published = new Date(publishedAt);
      const timeDifference = published.getTime() - now.getTime();

      if (timeDifference <= 0) {
        setTimeLeft(0);
        setIsPublished(true);
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
        return;
      }

      const secondsLeft = Math.floor(timeDifference / 1000);
      setTimeLeft(secondsLeft);
    };

    updateCountdown();
    intervalRef.current = setInterval(updateCountdown, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [publishedAt, setIsPublished]);

  if (!publishedAt || timeLeft === null || timeLeft <= 0) return null;

  const timeRemaining = DateHelper.getTimeLeft(new Date(publishedAt));

  return (
    <p className='mt-5 text-left text-lg font-bold text-primary-filled-default'>
      L'évènement sera publié dans {timeRemaining?.days}j {timeRemaining?.hours}
      h {timeRemaining?.minutes}m {timeRemaining?.seconds}s
    </p>
  );
}
